"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    VERSION: "1.1",
    API_URL: "/console/v2",
    API_HOST: "http://localhost",
    API_PORT: 3000,
    PORT: 3001
};
